import { render } from "./accountlist.vue?vue&type=template&id=5af987d1"
import script from "./accountlist.vue?vue&type=script&lang=js"
export * from "./accountlist.vue?vue&type=script&lang=js"
script.render = render

export default script